import { render, staticRenderFns } from "./diseasesInsectPests.vue?vue&type=template&id=27545661"
import script from "./diseasesInsectPests.vue?vue&type=script&lang=js"
export * from "./diseasesInsectPests.vue?vue&type=script&lang=js"
import style0 from "./diseasesInsectPests.vue?vue&type=style&index=0&id=27545661&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports